export function clearChildNodes(element: Element) {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

export function injectCode(
  parentElement: HTMLDivElement,
  html: string | undefined,
  js: string | undefined,
) {
  if (html) {
    parentElement.appendChild(document.createRange().createContextualFragment(html));
  }
  if (js) {
    const script = document.createElement('script');
    const content = document.createTextNode(js);
    script.appendChild(content);
    parentElement.appendChild(script);
  }
}

export function removeEvents(htmlEventNames: string[] | undefined, codeElementSelector: string) {
  if (htmlEventNames) {
    htmlEventNames.forEach(name => {
      const codePreviewHtmlCode: HTMLDivElement | null = document.querySelector(
        `${codeElementSelector}`,
      );
      if (codePreviewHtmlCode) {
        const handlerName = `handle${name}`;
        codePreviewHtmlCode.removeEventListener(name, (window as any)[handlerName]);
      }
    });
  }
}
export function getJSForEvents(htmlEventNames: string[] | undefined, codeElementSelector: string) {
  return htmlEventNames
    ? htmlEventNames
        .map(
          name =>
            `
document.querySelector(".code-preview-html-events-raised-title").style.display = "none";
document.querySelector(".code-preview-html-events-raised").style.display = "none";

function handle${name} (e) {
  var params = {};
  document.querySelector(".code-preview-html-events-raised-title").style.display = "flex";
  function handleClear() {
    document.querySelector(".code-preview-html-events-raised").innerHTML = "";
    document.querySelector(".code-preview-html-events-raised").style.display = "none";
    document.querySelector(".code-preview-html-events-raised-title").style.display = "none";
  }
  document.querySelector(".code-preview-html-events-raised-title button").addEventListener("click", handleClear);

  document.querySelector(".code-preview-html-events-raised").style.display = "block";
  document.querySelector(".code-preview-html-events-raised").innerHTML = '<p style="font-size: 12px; margin-top: 3px;">` +
            name +
            `: ' + JSON.stringify(e.detail) + '</p>' + document.querySelector(".code-preview-html-events-raised").innerHTML;
}

document.querySelector("${codeElementSelector}").removeEventListener("${name}", handle${name});
document.querySelector("${codeElementSelector}").addEventListener("${name}", handle${name})

`,
        )
        .join('\n\n')
    : '';
}
